import React from 'react';

import AssetsCreditResultContainer from '../../../containers/assets-credit-result-container';
import AppPageMain from '../../../modules/app-page/app-page--main';
import PageHeader from '../../../modules/page-header';

const CreditResultPage: React.FC = () => (
  <AppPageMain>
    <div className="container">
      <div className="row">
        <div className="col-19 col-lg-27 col-xl-35">
          <PageHeader
            items={[
              { link: '/assets', title: 'Активы' },
              { link: '#', title: 'Займы' },
            ]}
            iconType="assets"
          />
        </div>
      </div>
      <div className="row">
        <div className="col-19 col-lg-27 col-xl-35">
          <AssetsCreditResultContainer />
        </div>
      </div>
    </div>
  </AppPageMain>
);

export default CreditResultPage;
